// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"style_loaderContainer__orlpy","ldsRing":"style_ldsRing__4PCbI","lds-ring":"style_lds-ring__9_dn7"};